"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnScreen = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useOnScreen = function useOnScreen(ref, cb) {
  (0, _react.useEffect)(function () {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
          entry = _ref2[0];

      // Update our state when observer callback fires
      if (entry.isIntersecting) {
        cb();
      }
    }, {
      rootMargin: "0px"
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return function () {
      if (!ref.current) {
        return;
      }

      observer.unobserve(ref.current);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount
};

exports.useOnScreen = useOnScreen;